import { Box, Typography, Grid } from '@mui/material';
import React from 'react';
import CustomButton from '../../../components/common/button/CustomButton';
import { Link } from 'react-router-dom';

// Reusable component for each step in the list
const StepItem = ({ title, description }: { title: string; description: string; }) => (
    <li>
        <Typography variant="body1" paragraph>
            <strong>{title}:</strong> {description}
        </Typography>
    </li>
);

const WelcomeBottom = () => {
    return (
        <Box p={4} textAlign="left">
            <Typography variant="body1" paragraph>
                To get started, we've put together some resources and steps to help you hit the ground running::
            </Typography>
            <ol>
                {/* Reusing StepItem for each item */}
                <StepItem
                    title="Set up your profile"
                    description="Update your profile with the necessary details to personalise your experience."
                />
                <StepItem
                    title="Explore the Features"
                    description="Navigate through the various modules and familiarise yourself with the new functionalities."
                />
                <StepItem
                    title="Join Our Community"
                    description="Connect with other users, share your insights, and get tips from industry experts in our Community Forum."
                />
                <li >
                    <Typography variant="body1" paragraph>
                        <strong>Book an online call:</strong> Schedule a personalised training session with our support team to get a comprehensive walkthrough of our platform. Simpy choose a date and time below and one of our specialists will help you learn how to make the most of your system.
                    </Typography>

                    <Link to='https://www.managemymoves.co.uk/' target='_blank' style={{ display: 'flex', justifyContent: 'center', textDecoration: 'none' }}>
                        <CustomButton title="SCHEDULE CALL" style={{ marginBottom: '20px', borderRadius: 20 }} />
                    </Link>
                </li>
                <StepItem
                    title="Quick Question"
                    description="To better understand how we can tailor our support to your needs, could you share with us what is the biggest challenge your removals business is currently facing? Your feedback will help us provide the most relevant guidance and resources."
                />
            </ol>
            <Typography variant="body1" paragraph>
                Want to learn more? Watch this short tutorial to see how Manage My Moves can optimise your business. We have created a comprehensive, step-by-step guide to help you easily set up your first system.
            </Typography>

            <Box display="flex" justifyContent="center" my={2}>
                <Link to='https://www.youtube.com/@managemymoves' target='_blank'>
                    <img src="youtube.png" alt="" style={{ width: '100%' }} />
                </Link>
            </Box>

            <Typography variant="body1" paragraph>
                If you have any questions or need assistance, don't hesitate to reach out to our support team at info@managemymoves.com or call us at 03301 240292. We also have a live chat feature that you can access from the bottom right.
            </Typography>

            <Typography variant="body1" paragraph>
                We're here to help you succeed and look forward to supporting your growth!
            </Typography>

            <Typography variant="body1" paragraph>
                Best regards, <br />
                Manage My Moves <br />
                <a
                    style={{ color: 'inherit' }}
                    href='https://www.managemymoves.co.uk'
                    target='_blank'
                    rel="noopener noreferrer"
                >
                    www.managemymoves.co.uk
                </a>
            </Typography>
        </Box>
    );
};

export default WelcomeBottom;
